import { ChatRouteError } from '@pwa/components/chat/chat-route-error';
import { ChatWorkspace } from '@pwa/components/chat/chat-workspace';
import { chatQueries } from '@pwa/queries/chat';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import type { UIMessage } from 'ai';

export const Route = createFileRoute('/_dashboard/org/$orgId/ws/$wsId/c/$chatId')({
	loader: async ({ context, location, params }) => {
		if (location.pathname.endsWith('/settings')) {
			return [];
		}
		const { queryClient } = context;
		const { orgId, wsId, chatId } = params;
		const data = await queryClient.fetchQuery({
			...chatQueries.clientDetail(wsId, chatId, orgId),
			retry: false,
		});

		if (data === null) {
			return [];
		}

		return data;
	},
	preload: false,
	errorComponent: ClientChatError,
	component: RouteComponent,
});

function ClientChatError(props: ErrorComponentProps) {
	const { orgId, wsId } = Route.useParams();
	return <ChatRouteError {...props} backHref={`/org/${orgId}/ws/${wsId}`} backLabel='Back to workspace' />;
}

function RouteComponent() {
	const { chatId } = Route.useParams();
	const initialMessages = Route.useLoaderData();
	const isSettingsRoute = useRouterState({
		select: (state) => state.location.pathname.endsWith('/settings'),
	});

	if (isSettingsRoute) {
		return <Outlet />;
	}
	return (
		<ChatWorkspace chatId={chatId} initialMessages={initialMessages as UIMessage[]} session={{ kind: 'canonical' }} />
	);
}
